/**
 * Trạng thái đăng nhập hệ thống KBNN - DVC
 * dtnga3 (17.10.2022)
 */
export default {
  SaleInvoice: 1, // Phát hành hóa đơn điện tử
  FileDVC: 2, // Hồ sơ giao dịch Kho bạc điện tử
  FileDCSD: 3, // Hồ sơ đối chiếu số dư Kho bạc điện tử
};
